import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCartShopping } from "react-icons/fa6";
import { pricing_plan_data, user_add_to_cart } from "../api/Product";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const WhoisChecker = () => {
      const navigate = useNavigate();
      const [domain, setDomain] = useState("");
      const [extension, setExtension] = useState(".com");
      const [get_pricing_list, set_Pricing_List] = useState([])
      const [data, setData] = useState(null);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState("");

      useEffect(() => {
            localStorage.removeItem("cart_features")
      }, [])

      // const checkDomain = async (e) => {
      //       e.preventDefault();
      //       if (!domain) return;

      //       const fullDomain = `${domain}${extension}`;
      //       setLoading(true);
      //       setError("");
      //       setData(null);

      //       try {
      //             const response = await axios.get(`https://api.whois.vu/?q=${fullDomain}`);
      //             setData(response.data);
      //             console.log("response_checkDomain",response?.data)
      //       } catch (err) {
      //             setError("Error fetching domain details.");
      //       } finally {
      //             setLoading(false);
      //       }
      // };

      const checkDomain = async (e) => {
            e.preventDefault();
            if (!domain) return;

            const allExtensions = [".com", ".design", ".net", ".org", ".info", ".club"];
            const selectedFullDomain = `${domain}${extension}`;
            const otherExtensions = allExtensions?.filter((ext) => ext !== extension);

            setLoading(true);
            setError("");
            setData(null);

            try {
                  // Check selected domain first
                  const selectedResponse = await axios.get(`https://api.whois.vu/?q=${selectedFullDomain}`);
                  const otherResults = [];

                  // Check remaining domains
                  for (const ext of otherExtensions) {
                        const fullDomain = `${domain}${ext}`;
                        const response = await axios.get(`https://api.whois.vu/?q=${fullDomain}`);
                        otherResults.push({ domain: fullDomain, available: response?.data?.available });
                  }

                  // Set combined data
                  setData({
                        selected: { domain: selectedFullDomain, available: selectedResponse?.data?.available },
                        others: otherResults,
                  });
            } catch (err) {
                  setError("Error fetching domain details.");
            } finally {
                  setLoading(false);
            }
      };

      useEffect(() => {
            const handle_pricing_plan_data = async () => {
                  try {
                        const response = await pricing_plan_data();
                        set_Pricing_List(response?.data?.pricing_plans && response?.data?.pricing_plans[0]);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_pricing_plan_data();
      }, [])

      const handle_add_to_cart = async (data,price) => {
            try {
                  const formData = new FormData();
                  formData.append("quantity", "1");
                  formData.append("domain", data);
                  formData.append("domain_amount", price);
                  formData.append("order_type", "domain");
                  // <---------- User Authentciation token's ------------>
                  const token = localStorage.getItem("token");
                  const headers = {
                        "Authorization": `Bearer ${token}`
                  };
                  const response = await user_add_to_cart(headers, formData);
                  localStorage.setItem("add_cart_id", response?.data?.data?.id)
                  if (response?.data?.status == "200") {
                        // navigate("/checkout", { state: data });
                        navigate("/cart");
                  }
                  else if (response?.response?.data?.status == "401") {
                        toast.error("Please log in to access this page.")
                        setTimeout(() => {
                              navigate("/login")
                        }, 2000)
                  }
                  console.log("response", response)
            }
            catch (error) {
                  console.log("error", error)
            }
      }


      return (
            <div className="relative">
                  <section className="relative">
                        <div className="relative isolate overflow-hidden">
                              <div className="absolute inset-0 -z-10">
                                    <div className="absolute inset-0 bg-gradient-to-b from-black via-[#000000] to-black">
                                    </div>
                                    <div className="absolute inset-0 bg-[linear-gradient(rgba(255,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,0,0,0.03)_1px,transparent_1px)]" style={{ backgroundSize: '50px 50px' }} />
                                    <div className="absolute -left-[40%] -top-[50%] w-[80%] h-[100%] rounded-full bg-gradient-to-r from-blue-900/30 to-blue-600/20 blur-[128px] animate-slow-float">
                                    </div>
                                    <div className="absolute -right-[40%] -bottom-[50%] w-[80%] h-[100%] rounded-full bg-gradient-to-l from-blue-800/20 to-blue-700/20 blur-[128px] animate-slow-float-reverse">
                                    </div>
                              </div>
                              <div className="relative mx-auto max-w-7xl px-6 py-10 md:py-24 sm:py-15 lg:px-8 lg:py-10">
                                    <div className="md:flex flex-col lg:flex-row space-y-4 gap-16">
                                          <div className="flex-1 md:max-w-[200px] relative">
                                                <div className="relative mx-auto w-full animate-float">
                                                      <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-blue-600 rounded-2xl blur-xl opacity-20"></div>
                                                      <div className="relative bg-gray-50/80 backdrop-blur-xl rounded-2xl border border-blue-900/20 p-8 shadow-2xl">
                                                            <div className="space-y-6">
                                                                  <img className="zoom-in-zoom-out" src="assets/images/server-img.png" alt="Server" />
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>

                                          <div className="flex-1 lg:text-left">
                                                {/* <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border border-blue-800/30 mb-4">
                                                      <span className="text-sm font-medium text-blue-400">All Prices Per Year</span>
                                                </div> */}
                                                <h1 className="text-2xl font-bold tracking-tight sm:text-2xl">
                                                      <span className="text-white">Search Your</span>
                                                      <span className="mt-2 bg-gradient-to-r from-blue-700 to-blue-500 bg-clip-text text-transparent"> Domain Name</span>
                                                </h1>

                                                <form onSubmit={checkDomain}>
                                                      <div className="space-y-12">
                                                            <div className="mt-10 md:flex lg:flex items-end gap-x-3 gap-y-3 w-full space-y-3">
                                                                  <div className="w-full">
                                                                        <label htmlFor="domain" className="block text-sm text-white">Domain Name</label>
                                                                        <div className="mt-2">
                                                                              <div className="rounded-md overflow-hidden bg-white pl-3 outline-1 outline-gray-300 focus-within:outline-2 focus-within:outline-blue-600">
                                                                                    <input
                                                                                          type="text"
                                                                                          id="domain"
                                                                                          className="block py-3 pr-3 pl-1 w-full text-gray-900 placeholder:text-gray-400 focus:outline-none"
                                                                                          placeholder="Enter domain name"
                                                                                          value={domain}
                                                                                          onChange={(e) => setDomain(e.target.value)}
                                                                                    />
                                                                              </div>
                                                                        </div>
                                                                  </div>

                                                                  <div className="md:w-[300px]">
                                                                        <div className="flex justify-between items-center">
                                                                              <label htmlFor="extension" className="block text-sm text-white">Extension</label>
                                                                              {/* <span className="text-blue-500 font-bold">$9.99/-</span> */}
                                                                        </div>
                                                                        <div className="mt-2 grid grid-cols-1">
                                                                              <select id="extension" className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-3
                                                                               pr-8 pl-3 text-base text-gray-900 outline-1 outline-gray-300 focus:outline-2 focus:outline-blue-600"
                                                                                    value={extension} onChange={(e) => setExtension(e.target.value)}
                                                                              >
                                                                                    <option>.com</option>
                                                                                    <option>.design</option>
                                                                                    <option>.net</option>
                                                                                    <option>.org</option>
                                                                                    <option>.info</option>
                                                                                    <option>.club</option>
                                                                              </select>
                                                                              <svg className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end 
                                                                              text-gray-500" viewBox="0 0 16 16" fill="currentColor">
                                                                                    <path fillRule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 
                                                                                    1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
                                                                              </svg>
                                                                        </div>
                                                                  </div>

                                                                  <div>
                                                                        <button type="submit" className="rounded-lg md:w-[200px] bg-gradient-to-r from-blue-800 to-blue-600 px-6 py-[18px] text-sm font-semibold text-white shadow-sm hover:from-blue-700 hover:to-blue-500 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-blue-600 transition-all duration-200 text-center" disabled={loading}>
                                                                              {loading ? "Checking..." : "Submit"}
                                                                        </button>
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </form>

                                                {/* Display Result */}
                                                {error && <p className="mt-4 text-red-500">{error}</p>}
                                                {data && (
                                                      <>
                                                            {/*<------ Selected Domain --------->*/}
                                                            <div className="mt-6 bg-gray-800 p-4 rounded-md border-2 border-green-500">
                                                                  <h5 className="font-bold text-white">Selected Domain:</h5>
                                                                  <div className="grid grid-cols-5 gap-4 items-center text-gray-300">
                                                                        <p className="m-0 col-span-2"><strong>Domain:</strong> {data?.selected?.domain}</p>
                                                                        <p className="m-0"><strong>Available:</strong> {data?.selected?.available == "yes" ? "Yes ✅" : "No ❌"}</p>
                                                                        <p className="m-0"><strong>Price:</strong> ${" "}9.99</p>
                                                                        {
                                                                              data?.selected?.available == "yes" && (
                                                                                    <button onClick={() => {
                                                                                          handle_add_to_cart(data?.selected?.domain, "9.99")
                                                                                          localStorage.setItem("cart_id", data?.selected?.id)
                                                                                          localStorage.setItem("cart_totalPrice", "9.99")
                                                                                    }} className="text-green-500 hover:text-white hover:bg-green-500 items-center border-2 border-green-500 px-2 py-[10px] flex gap-3 text-sm rounded-lg justify-center">
                                                                                          <FaCartShopping size={16} /> Add To Cart
                                                                                    </button>
                                                                              )
                                                                        }

                                                                  </div>

                                                            </div>

                                                            {/*<------- Remaining Domains ---------->*/}
                                                            <div className="mt-6 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
                                                                  {data?.others?.map((item, idx) => (
                                                                        <div key={idx} className="bg-gray-800 p-4 rounded-md">
                                                                              <div className="grid grid-cols-5 gap-4 items-center text-gray-300">
                                                                                    <p className="m-0 col-span-2">{item?.domain}</p>
                                                                                    <p className="m-0">
                                                                                          {item?.available === "yes" ? (
                                                                                                <span className="text-green-600">Available ✅</span>
                                                                                          ) : (
                                                                                                <span className="text-red-500">Taken ❌</span>
                                                                                          )}
                                                                                    </p>
                                                                                    <p className="m-0"><strong>Price:</strong> ${" "} {(idx + 2) * 9.99}</p>

                                                                                    {item?.available == "yes" && (
                                                                                          <button onClick={() => {
                                                                                                handle_add_to_cart(item?.domain, (idx + 2) * 9.99)
                                                                                                localStorage.setItem("cart_id", data?.selected?.id)
                                                                                                localStorage.setItem("cart_totalPrice", (idx + 2) * 9.99)
                                                                                          }} className="text-blue-500 hover:text-white hover:bg-blue-500 items-center border-2 border-blue-500 px-2 py-[10px] flex gap-3 text-sm rounded-lg justify-center">
                                                                                                <FaCartShopping size={16} /> Add To Cart
                                                                                          </button>
                                                                                    )}
                                                                              </div>

                                                                        </div>
                                                                  ))}
                                                            </div>

                                                      </>
                                                )}

                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>
            </div>
      );
};

export default WhoisChecker;
